import { z } from 'zod';
import { validateUrl } from '../utils';

const LeaveAllocationSchema = z.object({
  allocated: z.number().min(0),
});

const dateString = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Must be YYYY-MM-DD');

const LeavePolicySchema = z.object({
  _id: z.string().optional(),
  fromDate: dateString,
  toDate: dateString,
  leaveTypes: z.record(LeaveAllocationSchema),
});

const BrandConfigurationSchema = z.object({
  tolerancePeriod: z.number().optional(),
  kimLeaves: z.array(LeavePolicySchema).optional(),
  brandLeaves: z.array(LeavePolicySchema).optional(),
});

export const BrandSchema = z.object({
  clientId: z.string().min(1, 'Client ID is required'),
  name: z.string().min(1, 'Brand name is required'),
  websiteLink: z.string().refine(validateUrl, 'Please enter a valid URL'),
  onboardingDate: z.string().optional(),
  agents: z.array(z.string()).optional(),
  alias: z.string().optional(),
  resources: z.array(z.any()).optional(),
  configuration: BrandConfigurationSchema.optional(),
});

export type BrandSchemaType = z.infer<typeof BrandSchema>;
